import { render } from "./Main.vue?vue&type=template&id=c38ec766&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=c38ec766&lang=scss&scoped=true"
import "./Main.vue?vue&type=style&index=1&id=c38ec766&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c38ec766"]])

export default __exports__